// export const globalAdminUrl = `http://216.48.189.197:8080`;
export const globalAdminUrl = `https://finco-admin.kalolytic.com`;
export const globalSRP = 'https://regisplus.nc.ntplc.co.th/dev/journey'; // used at notification need to check for delete when start work related to page.
// export const globalAdminUrl = `https://ekyc-admin.kalolytic.com`;
// export const globalAdminUrl = `https://ekyc-admin.kalolytic.com/onboarding-admin`;
